// Imports mesclados de ambos os arquivos
import {
  Flex,
  Link,
  IconButton,
  useDisclosure,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  VStack,
  Text,
} from "@chakra-ui/react";
import {
  CiBank,
  CiUser,
  // CiViewTimeline,
  CiMenuBurger,
  CiGrid41,
  CiReceipt,
  CiTimer,
} from "react-icons/ci";
import {
  MdColorLens,
  MdFeedback,
  MdNewspaper,
  MdNotificationsActive,
  MdOutlineAttachMoney,
} from "react-icons/md";
import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import SideBarLinkComponent from "./sideBarLinkComponent";
import Logo from "../Logo";
import { useEnsureAuthenticated } from "@/contexts/ensureAuthenticated";
import { userPermissions } from "@/contexts/userPermissions";
import { PermissionEnum } from "@/utils/permissionEnum";
import iconFgts from "@/assets/fgts-logo.svg";

// Imports adicionais necessários do Arquivo 1
import iconConsignado from "@/assets/consignado-logo.svg";
import { SidebarIcon } from "../SidebarIcon";
import { RouteConfig, routes } from "../../routes/index.ts"
import { useQuery } from "@tanstack/react-query";
import { findAllProposalsAtPendingBankAnalysis } from "@/services/consignado/proposal.service.ts";
import { getCountPendingWhiteLabels } from "@/services/whiteLabel.service";

export default function Sidebar() {
  const [isExpanded, setIsExpanded] = useState(false);
  const { user } = useEnsureAuthenticated();
  const permissions = userPermissions(user);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toggleExpand = (value: boolean) => setIsExpanded(value);
  const staleTime = import.meta.env.VITE_PROPOSALS_BANK_ANALYSIS_STALE_MINUTES;

  const { data } = useQuery({
    queryKey: ['proposal_pending_bank_analysis'],
    queryFn: async () => await findAllProposalsAtPendingBankAnalysis(),
    refetchInterval: parseInt(staleTime) * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: true
  })

  const { data: pendingWhiteLabelsCount } = useQuery({
    queryKey: ['whitelabel_pending_count'],
    queryFn: async () => await getCountPendingWhiteLabels(),
    refetchInterval: parseInt(staleTime) * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: true
  })

  const menuItems = [
    {
      group: "Saque Aniversário",
      icon: {
        content: <img src={iconFgts} alt="Ícone Crédito do Trabalhador" />,
        size: 30,
      },
      items: [
        {
          name: "proposals-page",
          text: "Propostas",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "analyze-bank",
          icon: CiTimer,
          text: "Análise Banco",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "product-page",
          icon: CiReceipt,
          text: "Produtos",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "financial-page",
          icon: MdOutlineAttachMoney,
          text: "Financeiro",
          permission: PermissionEnum.GRANATECH,
        },
      ],
    },
    {
      group: "Consignado CLT",
      icon: {
        content: <img src={iconConsignado} alt="Ícone Crédito do Trabalhador" />,
        size: 13,
      },
      items: [
        {
          name: "consignado-consult-cpf",
          text: "Lista de Consultas",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "propostas-leilao-clt",
          text: "Propostas Leilão CLT",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-proposals-page",
          text: "Propostas",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-banco-analise",
          text: "Análise Banco",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-product-page",
          text: "Produtos",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-financial-page",
          icon: MdOutlineAttachMoney,
          text: "Financeiro",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-arrecadacao",
          text: "Arrecadação",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-criterios-page",
          text: "Critérios de Crédito",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-engine-config-table",
          text: "Config. Motor de Crédito",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-aprovacao-pj",
          text: "Aprovação PJ",
          permission: PermissionEnum.GRANATECH,
        },
      ],
    },
    {
      name: "consignado-config-notificacoes",
      icon: MdNotificationsActive,
      text: "Módulo de disparos",
      permission: PermissionEnum.GRANATECH,
    },
    {
      group: "Repasse / Cobrança",
      icon: {
        content: <img src={iconConsignado} alt="Ícone de Repasses e Cobranças" />,
        size: 13,
      },
      items: [
        {
          name: "consignado-cobranca-clt",
          text: "Vinculos Ativos",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-cobranca-clt-vinculos-encerrados",
          text: "Vínculos Encerrados",
          permission: PermissionEnum.GRANATECH,
        },
         {
          name: "consignado-cobranca-clt-relatorio",
          text: "Relatório",
          permission: PermissionEnum.GRANATECH,
        },
        {
          name: "consignado-cobranca-clt-notificacoes",
          text: "Notificações",
          permission: PermissionEnum.GRANATECH,
        },
      ]
    },
    {
      name: "analyze-whitelabel",
      icon: MdColorLens,
      text: "WhiteLabel",
      permission: PermissionEnum.GRANATECH,
    },
    {
      name: "promotoras-page",
      icon: CiGrid41,
      text: "Promotoras",
      permission: PermissionEnum.GRANATECH,
    },
    // {
    //   name: "product-page",
    //   icon: CiReceipt,
    //   text: "Produtos",
    //   permission: PermissionEnum.GRANATECH,
    // },
    {
      name: "corban-table",
      icon: CiBank,
      text: "Corbans",
      permission: PermissionEnum.GRANATECH,
    },
    {
      name: "user-table",
      icon: CiUser,
      text: "Cadastro",
      permission: PermissionEnum.GRANATECH,
    },
    // {
    //   name: "financial-page",
    //   icon: MdOutlineAttachMoney,
    //   text: "Financeiro",
    //   permission: PermissionEnum.GRANATECH,
    // },
    {
      name: "feedbacks",
      icon: MdFeedback,
      text: "Feedbacks",
      permission: PermissionEnum.GRANATECH,
    },
    {
      name: "newsletter",
      icon: MdNewspaper,
      text: "Newsletter",
      permission: PermissionEnum.GRANATECH,
    },
  ];

  // --- PASSO 2: Copiar a função renderMenuItems ---
  // Esta função sabe como renderizar itens normais E grupos
  const notificationCountMap: Record<string, number | undefined> = {
    'consignado-banco-analise': data?.count,
    'analyze-whitelabel': pendingWhiteLabelsCount,
  };

  const renderMenuItems = (expanded: boolean) =>
    menuItems.map((item) => {
      if ("items" in item) {
        if (!expanded) return (
          "content" in item.icon ? (
            <SidebarIcon key={item.group} icon={item.icon.content} size={item.icon.size} />
          ) : null
        )

        return (
          <Flex key={item.group} flexDir="column" w="100%">
            {<Flex
              align="center"
              justify={expanded ? "flex-start" : "center"}
              mb={0}
              gap={expanded ? "0.6rem" : 0}
              w="100%"
              h="48px"
              px={expanded ? 4 : 0}
              transition="all 0.3s ease"
            >
              {"content" in item.icon ? (
                <SidebarIcon icon={item.icon.content} size={item.icon.size} />
              ) : null}
              {expanded && (
                <Text
                  color="white"
                  fontFamily="Lexend Deca"
                  transition="all 0.3s ease"
                  fontSize="lg"
                  whiteSpace="nowrap"
                >
                  {item.group}
                </Text>
              )}
            </Flex>
            }
            {item.items?.map((subItem) => {
              const route = routes.find((r: RouteConfig) => r.name === subItem.name);
              if (route && permissions.includes(subItem.permission)) {
                return (
                  <SideBarLinkComponent
                    key={route.path}
                    routeTo={route.path}
                    text={subItem.text}
                    isExpanded={expanded}
                    onClick={onClose}
                    isTopicItem={true}
                    notificationCount={notificationCountMap[subItem.name]}
                  />
                );
              }
              return null;
            })}
          </Flex>
        );
      }

      // Caso seja um item normal
      const route = routes.find((r: any) => r.name === item.name);
      if (route && permissions.includes(item.permission)) {
        return (
          <SideBarLinkComponent
            key={route.path}
            routeTo={route.path}
            icon={item.icon}
            text={item.text}
            isExpanded={expanded}
            onClick={onClose}
            notificationCount={notificationCountMap[item.name as string]}
          />
        );
      }
      return null;
    });

  // --- PASSO 3: Atualizar o JSX ---
  return (
    <>
      <IconButton
        size="sm"
        fontWeight="bold"
        display={{ base: "flex", md: "none" }}
        icon={<CiMenuBurger />}
        aria-label="Abrir Menu"
        onClick={onOpen}
        position="fixed"
        mt={2}
        left={2}
        fontSize={20}
        bg="white"
        color="black"
        borderRadius="full"
        boxShadow="md"
        _hover={{ bg: "green.500" }}
        zIndex="1000"
      />

      <Flex
        onMouseEnter={() => toggleExpand(true)}
        onMouseLeave={() => toggleExpand(false)}
        width={isExpanded ? "330px" : "60px"}
        boxShadow="5px 0 5px -2px rgba(0, 0, 0, 0.06)"
        flexDir="column"
        gap="2rem"
        transition="width 0.2s ease-in-out"
        bgGradient="linear(to-b, primary, secondary)"
        display={{ base: "none", md: "flex" }}
      >
        <Link as={RouterLink} to="/">
          <Flex
            height="100px"
            width="100%"
            alignItems="center"
            justifyContent="center"
            boxShadow="0 5px 5px -2px rgba(0, 0, 0, 0.05)"
          >
            <Logo
              variant="primary"
              objectFit="contain"
              width={isExpanded ? "30%" : "80%"}
            />
          </Flex>
        </Link>

        <Flex
          width="100%"
          height="100%"
          p="0 18px" // Pode ser p="0 12px" como no Arquivo 1, ajuste como preferir
          overflow="auto"
          direction="column"
          alignItems={isExpanded ? "flex-start" : "center"}
          gap="1rem"
          whiteSpace={"nowrap"}
        >
          {/* Substituímos a lista estática por nossa nova função */}
          {renderMenuItems(isExpanded)}
        </Flex>
      </Flex>

      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent bgGradient="linear(to-b, primary, secondary)">
          <DrawerCloseButton mt={2} color={"white"} />
          <DrawerHeader
            fontFamily="Lexend Deca"
            color={"white"}
            fontWeight="bold"
          >
            Menu
          </DrawerHeader>
          <DrawerBody>
            <VStack spacing={4} align="stretch">
              {/* Substituímos a lista estática por nossa nova função */}
              {renderMenuItems(true)}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
